$(function () {
  let headerHeight = $("div[id*='section-header-custom']").outerHeight();
  let pdpTabsHeight = $(".pdp-tabs").outerHeight();
   

  let overviewID = "#";
  overviewID = "#shopify-section-product-template-custom";
  $('.pdp-tab[data-tab-name="Overview"]').attr("href", overviewID);

  if ($(".pdp-features-list").length > 0) {
    let featuresID = $(".pdp-features-list")[0].id;
    $('.pdp-tab[data-tab-name="Features"]').attr("href", `#${featuresID}`);
  }

  if ($(".pdp-tech-specs").length > 0) {
    let techSpecsID = $(".pdp-tech-specs")[0].id;
    $('.pdp-tab[data-tab-name="Tech Specs"]').attr("href", `#${techSpecsID}`);
  }

  if ($(".pdp-oddict-app").length > 0) {
    let appID = $(".pdp-oddict-app")[0].id;
    $('.pdp-tab[data-tab-name="App"]').attr("href", `#${appID}`);
  }

  if ($(".pdp-reviews").length > 0) {
    let reviewsID = $(".pdp-reviews")[0].id;
    $('.pdp-tab[data-tab-name="Review"]').attr("href", `#${reviewsID}`);
  }

  $('a[href*="#"]').on("click", function (e) {
    e.preventDefault();

    if ($(this).attr("href") == "#") {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1000
      );
    } else {
      if ($(window).width() < 769) {
        $("html, body").animate(
          {
            scrollTop:
              $($(this).attr("href")).offset().top -
              headerHeight -
              pdpTabsHeight +
              2,
          },
          1000
        );
      } else {
        if ($(this).attr("data-tab-name") == "Overview") {
          $("html, body").animate(
            {
              scrollTop:
                $($(this).attr("href")).offset().top - headerHeight + 2,
            },
            1000
          );
        } else {
          $("html, body").animate(
            {
              scrollTop:
                $($(this).attr("href")).offset().top -
                headerHeight -
                pdpTabsHeight +
                2,
            },
            1000
          );
        }
      }
    }
  });

  if ($(window).width() < 769) {
    $(".pdp-features-list .pdp-features-images-wrap").flickity({
      pageDots: false,
    });

    $(".pdp-gallery-wrap").flickity({
      cellAlign: "left",
      pageDots: false,
      freeScroll: true,
      prevNextButtons: false,
    });
  } else {
    $(".pdp-gallery-wrap").flickity({
      cellAlign: "left",
      pageDots: false,
    });

    $(document).on("recommendations:loaded", function () {
      $(".pdp-recommendations-custom .grid").flickity({
        cellAlign: "left",
        pageDots: false,
        groupCells: true,
      });
    });
  }

  $(window).scroll(function () {
    let scrollTop = $(window).scrollTop();

    let overviewBottom =
      $("div[id*='section-product-template-custom']").offset().top -
      headerHeight +
       $("div[id*='section-product-template-custom']").outerHeight();

    // let svgBlocksTop = $('#shopify-section-pdp-svg-text-blocks').offset().top - headerHeight;
    // let svgBlocksBottom = svgBlocksTop + $('#shopify-section-pdp-svg-text-blocks').outerHeight();

    let techSpecsTop;
    if ($(".pdp-tech-specs").length > 0) {
      techSpecsTop =
        $(".pdp-tech-specs").offset().top - headerHeight - pdpTabsHeight;
    }

    let appTop;
    if ($(".pdp-oddict-app").length > 0) {
      appTop = $(".pdp-oddict-app").offset().top - headerHeight - pdpTabsHeight;
    }

    let reviewsTop;
    if ($(".pdp-reviews").length > 0) {
      reviewsTop =
        $(".pdp-reviews").offset().top - headerHeight - pdpTabsHeight;
    }

    let featuresListTop;

    if ($(".pdp-features-list").length > 0) {
      pdpTabsHeight = $("#shopify-section-pdp-tabs").outerHeight();

      featuresListTop =
        $(".pdp-features-list").offset().top - headerHeight - pdpTabsHeight;

      let featuresListHeight = $(".pdp-features-list").outerHeight();

      let featuresListBottom = featuresListTop + featuresListHeight;

      let featuresListImagesHeight = $(
        ".desktop-only .pdp-features-images-wrap"
      ).outerHeight();

      let featuresListBottomCutoff =
        featuresListBottom -
        $(".desktop-only .pdp-feature-image").last().outerHeight();

      let featuresListHeightToCutoff =
        featuresListHeight -
        $(".desktop-only .pdp-feature-image").last().outerHeight();

      let topLimit =
        featuresListImagesHeight -
        $(".desktop-only .pdp-feature-image").last().outerHeight() -
        featuresListHeightToCutoff +
        headerHeight +
        pdpTabsHeight;

      if (
        scrollTop >= featuresListTop &&
        scrollTop <= featuresListBottomCutoff
      ) {
        let scrollPercentage =
          (scrollTop - featuresListTop) / featuresListHeightToCutoff;

        let topVal = scrollPercentage * topLimit * -1 + "px";

        $(".desktop-only .pdp-features-images-wrap").css("top", topVal);
      } else if (scrollTop < featuresListTop) {
        $(".desktop-only .pdp-features-images-wrap").css("top", 0);
      } else if (scrollTop > featuresListBottomCutoff) {
        let topVal = topLimit * -1 + "px";

        $(".desktop-only .pdp-features-images-wrap").css("top", topVal);
      }
    }

    if (scrollTop > reviewsTop) {
      $(".pdp-tab").removeClass("selected-tab");
      $('.pdp-tab[data-tab-name="Review"]').addClass("selected-tab");
    } else if (scrollTop > techSpecsTop) {
      $(".pdp-tab").removeClass("selected-tab");
      $('.pdp-tab[data-tab-name="Tech Specs"]').addClass("selected-tab");
    } else if (scrollTop > appTop) {
      $(".pdp-tab").removeClass("selected-tab");
      $('.pdp-tab[data-tab-name="App"]').addClass("selected-tab");
    } else if (scrollTop > featuresListTop) {
      $(".pdp-tab").removeClass("selected-tab");
      $('.pdp-tab[data-tab-name="Features"]').addClass("selected-tab");
    } else {
      $(".pdp-tab").removeClass("selected-tab");
      $('.pdp-tab[data-tab-name="Overview"]').addClass("selected-tab");
    }
  });

  $(".pdp-tabs").css("top", headerHeight);

  $(".pdp-tab").click(function () {
    // $('.pdp-tab').removeClass('selected-tab');
    // $(this).addClass('selected-tab');
  });

  $(".product-tab").click(function (e) {
    if ($(this).attr("data-tab") != "Manual") {
      e.preventDefault();
      $(".product-tab").removeClass("selected-tab");
      $(this).addClass("selected-tab");
      let tab = $(this).attr("data-tab");

      $(".product-tab-content").removeClass("selected-tab-content");
      $(`.product-tab-content[data-tab="${tab}"]`).addClass(
        "selected-tab-content"
      );
    }
  });

  $(".pdp-video .play-button").click(function () {
    $("body").addClass("video-modal-active");
  });

  $(".pdp-video .modal-close").click(function () {
    $("body").removeClass("video-modal-active");
    $(".video-wrapper iframe").each(function () {
      $(this).attr("src", $(this).attr("src"));
    });
  });

  $(".additional-info-header").click(function () {
    $(this).hide();
    $(this).siblings(".additional-info-container").show();

    if ($(window).width() < 769) {
      if ($(this).parents(".pdp-oddict-app").length > 0) {
        $(this).siblings(".additional-info-border-top").hide();

        $(".phone-images").flickity({
          pageDots: false,
          freeScroll: true,
          prevNextButtons: false,
          initialIndex: 1,
        });
      }
    }
  });

  $(".additional-info-close-button").click(function () {
    $(this).parent().hide();
    $(this).parent().siblings(".additional-info-header").show();
  });

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      $("body").removeClass("video-modal-active");
      $(".video-wrapper iframe").each(function () {
        $(this).attr("src", $(this).attr("src"));
      });
    }
  });

  if ( $("div[id*='shopify-product-reviews']").length > 0) {
    const reviewObserver = new MutationObserver(function (mutations_list) {
      mutations_list.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (added_node) {
          if (added_node.className == "spr-container") {
            if ($(".spr-review").length > 0) {
              let reviewJson = $(".pdp-reviews")
                .find('script[type="application/ld+json"]')
                .text();
              let reviewObj = JSON.parse(reviewJson);
              let rating = parseFloat(reviewObj.ratingValue);
              let rounded = (Math.round(rating * 10) / 10).toFixed(1);

              $(".spr-summary").prepend(
                '<div class="rating-container">' + rounded + "</div>"
              );
            }
          }

          if (added_node.className == "spr-pagination") {
            $(".spr-pagination-prev a").text("PREVIOUS");
            $(".spr-pagination-next a").text("NEXT");
          }
        });
      });
    });

    reviewObserver.observe( $("div[id*='shopify-product-reviews']")[0], {
      subtree: true,
      childList: true,
    });
  }
});
